import styled from "styled-components";
import { Wrapper as Heading } from "components/Heading/Heading.style";
import { font, rwd } from "styles/Mixins";
export const Wrapper = styled.div`
  width: 100%;
  padding: 100px 34px;
  margin: 0 auto;
  font-family: BrownLLWeb;

  ${Heading} {
    margin-bottom: 32px;
  }

  ${rwd({
    xLarge: `
        max-width: 1400px;
        padding: 0 20px;
        padding-top: 200px;
        padding-bottom: 15%;

        ${Heading} {
          margin-bottom: 48px;
        }

      `,
  })}

  h1 {
    font-size: 48px;
    line-height: 60px;

    ${rwd({
      xLarge: `
        font-size: 210px;
        line-height: 210px;
      `,
    })}
  }

  h3 {
    font-size: 25px;
    line-height: 31.5px;

    ${rwd({
      xLarge: `
        font-size: 38px;
        line-height: 48px;
      `,
    })}
  }

  p {
    color: #ffffff;
    ${font("BrownLLWeb", "19px", 400)}
    line-height: 31.5px;
    margin: 0;

    ${rwd({
      xLarge: `
      font-size: 21px;
      line-height: 35px;
    `,
    })}
  }

  a {
    color: rgb(0, 43, 71);
  }
`;
